<template>
  <div id="app">
  <div class="big-data-bg">
  </div>
   <div class="big-data-content">
     <router-view/>
   </div>

  </div>
</template>

<script>
  function resize() {
    var width = window.innerWidth;
    var scale = width/1920;
    document.querySelector('body').style.zoom=(scale)
  }
export default {
  data() {
    return {

    }
  },
  methods: {
  },
  mounted()  {
    // resize()
  },
  components:  {
  },
  computed: {
  }
}
</script>

<style>
  .sheng{
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap
  }
  #app{
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    font-size: 12px;
    overflow-x: hidden;
    margin:0 auto;
    color:#22313f;
    background:#f7fafc;
    /* padding:0 2vw 2vw 2vw; */
  }
  .re{
    position: relative;
  }
  .flex{
    display: flex;
  }
  .flex1{
    flex:1;
  }
  .flex_c{
    justify-content: center;
    align-items: center;
  }
  .flex_s_c{
    align-items: center;
  }
  .flex_s_jc{
    justify-content: center;
  }
  .flex_s_b{
    justify-content: space-between;
  }
  .flex_s_a{
    justify-content: space-around;
  }
  .flex_co{
    flex-direction: column;
  }
  .flex_w{
    flex-wrap: wrap;
  }
  .auto{
    margin:0 auto;
  }
  .text_center{
    text-align: center;
  }
  .flex_end{
    align-self: flex-end;
  }
  .border{
    border: 1px solid rgba(176,149,91,.5);
  }
  .font12{
    font-size: 12px;
  }
  .font14{
    font-size: 14px;
  }
  .font16{
    font-size: 16px;
  }
  .font18{
    font-size: 18px;
  }
  .font20{
    font-size: 20px;
  }
  .font28{
    font-size: 28px;
  }
  /*共同  图表  样式*/
  .echart_box{
    margin-top:1.5vw;
  }
  .com_box{
    position: relative;
    margin-bottom:2vh;
    z-index: 1;
  }
  .com_box_title{
    position: absolute;
    left:1vw;
    top:1vh;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
  }
  .com_box_title>s{
    width: 10px;
    height: 10px;
    background: #B0955B;
    display: block;
    margin-right:.3vw;
  }
  /*左边样式*/
  .left_box{
    width: 22vw;
    position: relative;
  }
  .ticket_reservation{
    width: 100%;
  }
  /*中间地图样式*/
  .center_box{
    width:50vw;
    position: relative;
  }
  .main_map{
    width: 100%;
    height:88vh;
  }
  /*右边样式*/
  .right_box{
    width:22vw;
    position: relative;
  }


  .drag-container_body {
    overflow: hidden;
    display: flex;
    perspective: 1000px;
    transform-style: preserve-3d;
  }

  #drag-container, #spin-container {
    position: relative;
    display: flex;
    margin: auto;
    transform-style: preserve-3d;
    transform: rotateX(-30deg);
  }
  #drag-container span{
    transform-style: preserve-3d;
    position: absolute;
    left: 0;
    top: 0;
    width: 100px;
    height: 100px;
    line-height: 100px;
    border-radius: 50%;
    font-size: 20px;
    text-align: center;
    -webkit-box-reflect: below 10px linear-gradient(transparent, transparent, #0005);
    background: #B09457;
    color:#fff;
  }
  #drag-container img, #drag-container video {
    transform-style: preserve-3d;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    line-height: 200px;
    font-size: 50px;
    text-align: center;
    box-shadow: 0 0 8px #fff;
    -webkit-box-reflect: below 10px linear-gradient(transparent, transparent, #0005);
  }

  #drag-container img:hover, #drag-container video:hover {
    box-shadow: 0 0 15px #fffd;
    -webkit-box-reflect: below 10px linear-gradient(transparent, transparent, #0007);
  }

  #drag-container p {
    font-family: Serif;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%,-50%) rotateX(90deg);
    color: #fff;
  }

  #ground {
    width: 900px;
    height: 900px;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%,-50%) rotateX(90deg);
    background: -webkit-radial-gradient(center center, farthest-side , #9993, transparent);
  }


  #carousel-container {
    width: 100%;
    height: 100%;
  }

  @keyframes spin {
    from{
      transform: rotateY(0deg);
    } to{
        transform: rotateY(360deg);
      }
  }
  @keyframes spinRevert {
    from{
      transform: rotateY(360deg);
    } to{
        transform: rotateY(0deg);
      }
  }
  .wether_box_page{
    width: 30vw;
    height: 3vw;
    background: white;
  }
  .wether_box_page body{
    overflow-x:hidden;
    overflow-y:auto;
    color: #fff;
    background: #191E21;
  }
  .code1,.divCurrentWeather,.code1 a{
    display: flex;
  }
  .divCurrentWeather strong{
    margin:0 10px;
  }
  .divCurrentWeather img{
    margin: 0 10px;
  }
  .f1{
    margin:0 5px;
  }
  .csssprite{
    display: none;
  }
  #main>div:first-child>div:last-child>div:last-child{
    display: none;
  }
  /* .big-data-bg{
      background:url("../static/img/big_data_bg.png") top center repeat-y;
      background-size: contain;
      position: fixed;
      right: 0;
      min-width: 100vw;
      top: 0;
      padding: 24px;
      height: 100vw;
  } */
    .big-data-content{
        position: relative;
        min-height: 100vh;
        background: linear-gradient(180deg, #f7fafc 0%, #eef4f8 100%);
    }

</style>



// WEBPACK FOOTER //
// src/App.vue